import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeStyle as _normalizeStyle, withCtx as _withCtx } from "vue"

import { ref, getCurrentInstance, withDefaults, onMounted, watch } from 'vue';
import translate from '@/api/translate';

interface main {
	id?: string | number,
	size?: string,
	ValueKey?: string,
	LabelKey?: string,
	width?: string | number,
	disabled?: boolean,
	IsAuto?: boolean,
}
export default /*#__PURE__*/_defineComponent({
  __name: 'WarehouseSelect',
  props: {
    id: { default: "" },
    size: { default: "default" },
    ValueKey: { default: "value" },
    LabelKey: { default: "label" },
    width: { default: "100%" },
    disabled: { type: Boolean, default: false },
    IsAuto: { type: Boolean, default: false }
  },
  emits: ["update:id", "change", "clear"],
  setup(__props: any, { emit: __emit }) {

;

const props = __props;

const { proxy } = getCurrentInstance() as any;
const emits = __emit;
const WarehouseId = ref<any>("");
const WarehouseList = ref<any>([]);
const loading = ref(false);
const placeholder = ref(translate.ShowText('请选择')); // 请选择...

watch(() => props.id, (n: any) => {
	WarehouseId.value = n;
});

onMounted(() => {
	WarehouseId.value = props.id;
	if (props.IsAuto) {
		if (proxy.$store.state.IsRefreshWarehouse) {
			GetData();
		} else {
			if (proxy.$store.state.WarehouseList.length > 0) {
				WarehouseList.value = proxy.$store.state.WarehouseList;
				if (!WarehouseId.value && WarehouseList.value.length == 1) {
					WarehouseId.value = WarehouseList.value[0].value;
					emits("update:id", WarehouseList.value[0].value);
					emits("change", WarehouseList.value[0].value);
				}
			} else {
				GetData()
			}
		}
	}
});

const WarehouseChange = (data: any) => {
	emits("update:id", data);
	emits("change", data);
};
const WarehouseClear = () => {
	emits("clear");
};
const SelectFocus = () => {
	if (proxy.$store.state.IsRefreshWarehouse) {
		GetData();
	} else {
		if (proxy.$store.state.WarehouseList.length > 0) {
			WarehouseList.value = proxy.$store.state.WarehouseList;
			if (!WarehouseId.value && WarehouseList.value.length == 1) {
				WarehouseId.value = WarehouseList.value[0].value;
				emits("update:id", WarehouseList.value[0].value);
				emits("change", WarehouseList.value[0].value);
			}
		} else {
			GetData()
		}
	}
};
const GetData = () => {
	loading.value = true;
	proxy.$api.tokenRequest({
		url: '/admin/warehouse/listByType',
		data: {
			type: 1,
		},
		success: (res: any) => {
			loading.value = false;
			WarehouseList.value = res.data;
			if (!WarehouseId.value && WarehouseList.value.length == 1) {
				WarehouseId.value = WarehouseList.value[0].value;
				emits("update:id", WarehouseList.value[0].value);
				emits("change", WarehouseList.value[0].value);
			}
			proxy.$store.commit("GetAllList", {
				type: 1,
				data: res.data,
			});
		},
		fail: () => {
			loading.value = false;
		},
	});
};

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!

  return (_openBlock(), _createBlock(_component_el_select, {
    "remote-show-suffix": "",
    filterable: "",
    clearable: "",
    style: _normalizeStyle({ 'width': `${_ctx.width}` }),
    disabled: _ctx.disabled,
    size: _ctx.size,
    modelValue: WarehouseId.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((WarehouseId).value = $event)),
    loading: loading.value,
    onFocus: SelectFocus,
    placeholder: placeholder.value,
    onChange: WarehouseChange,
    onClear: WarehouseClear
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(WarehouseList.value, (v) => {
        return (_openBlock(), _createBlock(_component_el_option, {
          key: v[_ctx.ValueKey],
          label: v[_ctx.LabelKey],
          value: v[_ctx.ValueKey]
        }, null, 8, ["label", "value"]))
      }), 128))
    ]),
    _: 1
  }, 8, ["style", "disabled", "size", "modelValue", "loading", "placeholder"]))
}
}

})